export default __webpack_public_path__ + "static/img-5-6f6c562ff5d2d48f1cc6b7eeff7c9f9c.png";